import { Language } from '@infinitaslearning/il.authentication.avatar';

export const idpCheckedStorageKey = 'isIDPSessionChecked';

export function isIdpSessionChecked(): boolean {
  return sessionStorage.getItem(idpCheckedStorageKey) === 'true';
}

export function getIdpLanguage(): Language {
  const browserLanguage = window.navigator.language.split('-')[0].toLowerCase()
  switch (browserLanguage) {
    case 'nl':
      return Language.nlNL
    case 'sv':
      return Language.svSE
    default:
      return Language.enUS
  }
}
